import React from 'react';
import { DragonDropWrapper } from '../../../../../shared/DragonDrop/DragonDrop';

const data = {
  type: 'bench',
  ptype: 'If/then Statement',
  title: 'If/then Statement',
  options: {
    'option-1': {
      id: 'option-1',
      ptype: 'Natural If/Then',
      content: 'If you leave your toys on the floor, they may get broken.',
    },
    'option-2': {
      id: 'option-2',
      ptype: 'Natural If/Then',
      content: 'If you don’t eat your dinner, you will be hungry later.',
    },
    'option-3': {
      id: 'option-3',
      ptype: 'Logical If/Then',
      content:
        'If you don’t follow the rules at the park, then we will go home early.',
    },
    'option-4': {
      id: 'option-4',
      ptype: 'Logical If/Then',
      content:
        'If you two keep fighting, then you will have to go to separate rooms.',
    },
    'option-5': {
      id: 'option-5',
      ptype: 'Logical If/Then',
      content: 'If you color on the table, I will take the crayons away.',
    },
    'option-6': {
      id: 'option-6',
      ptype: 'Natural If/Then',
      content: 'If you don’t tie your shoelaces, you may trip and fall.',
    },
    'option-7': {
      id: 'option-7',
      ptype: 'Natural If/Then',
      content: 'If you stay up too late, then you will be tired tomorrow.',
    },
    'option-8': {
      id: 'option-8',
      ptype: 'Logical If/Then',
      content:
        'If you don’t finish your homework, then you will not get screen time later.',
    },
    'option-9': {
      id: 'option-9',
      ptype: 'Logical If/Then',
      content:
        'If you continue to throw your blocks, then I will put them away.',
    },
  },
  columns: {
    'column-1': {
      id: 'column-1',
      title: 'If/then Statement',
      optionIds: [
        'option-1',
        'option-2',
        'option-3',
        'option-4',
        'option-5',
        'option-6',
        'option-7',
        'option-8',
        'option-9',
      ],
    },
    'column-2': {
      id: 'column-2',
      title: 'Natural If/Then',
      optionIds: [],
    },
    'column-3': {
      id: 'column-3',
      title: 'Logical If/Then',
      optionIds: [],
    },
  },
  columnOrder: ['column-1', 'column-2', 'column-3'],
  showErrorMessage: false,
};

const LogicalIfThenActivity = () => {
  return (
    <div>
      <section
        className='mx-auto my-8 w-full max-w-[1100px] min-w-0'
        style={{ boxSizing: 'border-box' }}
      >
        <div className='flex w-full min-w-0 flex-col items-center justify-center gap-4 rounded-lg border border-slate-300 bg-white p-4 text-center text-2xl font-semibold shadow-md'>
          <div>
            <p>
              Determine whether the statement is a natural or logical if/then
              statement.
            </p>
            <p className='text-lg '>
              Then drag and drop the statement into the correct category.
            </p>
          </div>
          <p className='text-lg font-normal'>
            Remember, natural if/then statements include a consequence that will
            occur naturally if the child continues the behavior, while a logical
            if/then statement includes a consequence set by the parent if the
            child continues the behavior.
          </p>
        </div>
      </section>
      <DragonDropWrapper content={data} />
    </div>
  );
};

export default LogicalIfThenActivity;
